module.exports = __webpack_public_path__ + "img/chambre 5.563e7c51.jpeg";